import React from 'react'

const SocialBtns = props => {
  const url = window.location.href
  const twitterHref = `http://twitter.com/share?text=SDG Atlas 2020 Goal ${props.goal}: ${props.headline}&url=${url}&hashtags=GlobalGoals,sdg${props.goal}`
  const facebookHref = `https://www.facebook.com/sharer/sharer.php?u=${url}`
  return (
    <div className='socialWrapper'>
      <svg width='120' height='70'>
        <defs>
          <filter id='gooey-effect'>
            <feGaussianBlur
              in='SourceGraphic'
              stdDeviation='10'
              colorInterpolationFilters='sRGB'
              result='blur'
            ></feGaussianBlur>
            <feColorMatrix
              in='blur'
              mode='matrix'
              values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9'
              result='gooey'
            ></feColorMatrix>
          </filter>
        </defs>
        <g filter='url(#gooey-effect)'>
          <a href={twitterHref}>
            <circle
              className='socialBtn twitter-btn'
              cx='30'
              cy='30'
              r='25'
              fill='#bdbdbd'
            ></circle>
          </a>
          <a href={facebookHref}>
            <circle
              className='socialBtn fb-btn'
              cx='85'
              cy='30'
              r='25'
              fill='#bdbdbd'
            ></circle>
          </a>
        </g>
        <g>
          <path
            transform='translate(80, 20) scale(1.2)'
            d='M4.775 14.163V7.08h1.923l.255-2.441H4.775l.004-1.222c0-.636.06-.977.958-.977H6.94V0H5.016c-2.31 0-3.123 1.184-3.123 3.175V4.64H.453v2.44h1.44v7.083h2.882z'
            fill='#fff'
          ></path>
          <path
            transform='translate(25,23) scale(1.2)'
            d='M5.987 2.772l.025.425-.429-.052c-1.562-.2-2.927-.876-4.086-2.011L.93.571.784.987c-.309.927-.111 1.906.533 2.565.343.364.266.416-.327.2-.206-.07-.386-.122-.403-.096-.06.06.146.85.309 1.161.223.434.678.858 1.176 1.11l.42.199-.497.009c-.481 0-.498.008-.447.19.172.564.85 1.162 1.606 1.422l.532.182-.464.277a4.833 4.833 0 0 1-2.3.641c-.387.009-.704.044-.704.07 0 .086 1.047.572 1.657.762 1.828.564 4 .32 5.631-.641 1.159-.685 2.318-2.045 2.859-3.363.292-.702.583-1.984.583-2.6 0-.398.026-.45.507-.927.283-.277.55-.58.6-.667.087-.165.078-.165-.36-.018-.73.26-.832.226-.472-.164.266-.278.584-.78.584-.928 0-.026-.129.018-.275.096a4.79 4.79 0 0 1-.755.294l-.464.148-.42-.286C9.66.467 9.335.293 9.163.24 8.725.12 8.055.137 7.66.276c-1.074.39-1.752 1.395-1.674 2.496z'
            fill='#fff'
          ></path>
        </g>
      </svg>
    </div>
  )
}

export default SocialBtns
